/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var FormatType;

(function (FormatType) {
  FormatType["CSV"] = "csv";
  FormatType["XLSX"] = "xlsx";
})(FormatType || (FormatType = {}));